const labels = {
  All: { 'See the offering': '제안을 참조하십시오' },
  FacilityDetails: { 'Ref: Page title': '시설 세부 사항', 'Ref: Review': '검토' },
  FacilitiesList: { 'Ref: Page title': '시설', 'Ref: See details': '자세히보다' },
};
export default labels;
